import * as types from "./types";
import {
    getChartOfAccountAxios, 
    getChartOfAccountIDAxios,
    deleteChartOfAccountAxios,
    postChartOfAccountAxios,
    putChartOfAccountAxios
} from "./services";

export async function getChartOfAccountListAction({commit}) {
    commit(types.LOADING_CHARTOFACCOUNT, true);
    try {
        const {data} = await getChartOfAccountAxios();
        commit(types.GET_CHARTOFACCOUNT_LIST, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_CHARTOFACCOUNT, false);
    }
   
}

export async function getChartOfAccountIDAction({commit},payload) {
    commit(types.LOADING_CHARTOFACCOUNT, true);
    try {
        const {data} = await getChartOfAccountIDAxios(payload);
        commit(types.GET_CHARTOFACCOUNT_ID, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_CHARTOFACCOUNT, false);
    }
}

export async function removeChartOfAccountAction({commit}, payload) {
    commit(types.LOADING_CHARTOFACCOUNT, true);
    try {
        await deleteChartOfAccountAxios(payload);
        commit(types.REMOVE_CHARTOFACCOUNT, payload);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_CHARTOFACCOUNT, false);
    }
}

export async function addChartOfAccountAction({ commit }, payload) {
    commit(types.LOADING_CHARTOFACCOUNT, true);
    try {
      const { data } = await postChartOfAccountAxios(payload);
      payload.id = data.result.id;
      commit(types.ADD_CHARTOFACCOUNT, payload);
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_CHARTOFACCOUNT, false);
    }
  }

  export async function updateChartOfAccountAction({ commit }, payload) {
    commit(types.LOADING_CHARTOFACCOUNT, true);
    try {
      console.log("payloadssssss", payload);
      await putChartOfAccountAxios(payload);
      commit(types.UPDATE_CHARTOFACCOUNT, payload);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_CHARTOFACCOUNT, false);
    }
  }
